import { memo } from 'react'
import Button from '@mui/material/Button'

interface AddFunctionalityBtnProps {
	onAddPreset: () => void
	className?: string;
}

export const AddNewPresetBtn = memo((props: AddFunctionalityBtnProps) => {
	const {
		className,
		onAddPreset
	} = props

	return (
		<Button
			sx={{ py: 0.05 }}
			variant="contained"
			size="small"
			className={className}
			onClick={onAddPreset}
		>
			Add new preset
		</Button>
	)
})